import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { tab: String };

  connect() {
    this.boundHandleClick = this.handleClick.bind(this);
    this.element.addEventListener("click", this.boundHandleClick);

    if (this.tabValue) {
      requestAnimationFrame(() => {
        const link = this.element.querySelector(`[href="#${this.tabValue}"]`);
        link?.click();
      });
    }
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundHandleClick);
  }

  handleClick(event) {
    const link = event.target.closest('[data-tabs-target="tab"]');
    if (!link) return;

    const tab = link.getAttribute("href")?.replace("#", "");
    if (!tab) return;

    const input = document.querySelector('input[name="tab"]');
    if (input) input.value = tab;
  }
}
